import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';

import PhotoCommon from '../PhotoCommon';

const styles = (theme) => ({
});

/**
 * 写真種別の情報一覧
 * @type { [key: string]: PhotoCommon.PhotoType }
 */
const PHOTO_TYPES = {
  /** 写真種別定義(電柱番号写真) */
  bangou: {
    componentId: 'bangou',
    name: '電柱番号写真',
    maxFileCount: 1,
  },

  /** 写真種別定義(全景写真(施工前)) */
  zenkei_mae: {
    componentId: 'zenkei_mae',
    type: 'zenkei',
    name: '全景写真(施工前)',
    maxFileCount: 2,
  },

  /** 写真種別定義(全景写真(施工後)) */
  zenkei_ato: {
    componentId: 'zenkei',
    name: '全景写真(施工後)',
    maxFileCount: 1,
  },

  /** 写真種別定義(近景写真(施工後)) */
  kinkei: {
    componentId: 'kinkei',
    name: '近景写真(施工後)',
    maxFileCount: 1,
  },

  /** 写真種別定義(通信引込線施設箇所付近) */
  tsusin: {
    componentId: 'tsusin',
    name: '通信引込線施設箇所付近',
    maxFileCount: 1,
    editableControl: 'hasCommunicationLine',
  },

  /** 写真種別定義(電力線最接近箇所(施工後)) */
  densen: {
    componentId: 'densen',
    name: '電力線最接近箇所(施工後)',
    maxFileCount: 1,
  },
};

/** 遷移元画面ごとの表示項目定義 */
const DISPLAY_ITEMS = {

  /** 1027_竣工届申込登録（契約電柱）※線設備 */
  '1027_sen': {
    editablePage: true,
    items: [
      'zenkei_ato',
    ],
  },

  /** 1027_竣工届申込登録（契約電柱）※点設備 */
  '1027_ten': {
    editablePage: true,
    items: [
      'zenkei_ato',
    ],
  },

  /** 1038_撤去竣工届申込登録（契約電柱）（線） */
  '1038': {
    editablePage: true,
    items: [
      'zenkei_ato',
    ],
  },

  /** 1064_撤去竣工届申込登録（契約電柱）（点） */
  '1064': {
    editablePage: true,
    items: [
      'zenkei_ato',
    ],
  },

  /** 1487_竣工届申込登録（契約電柱）(改修依頼)※線設備 */
  '1487_sen': {
    editablePage: true,
    items: [
      'zenkei_ato',
    ],
  },

  /** 1487_竣工届申込登録（契約電柱）(改修依頼)※点設備 */
  '1487_ten': {
    editablePage: true,
    items: [
      'zenkei_ato',
    ],
  },

  /** 1603_契約相違申込線設備入力（契約電柱） */
  '1603': {
    editablePage: true,
    items: [
      'zenkei_ato',
    ],
  },

  /** 1605_契約相違申込点設備入力（契約電柱） */
  '1605': {
    editablePage: true,
    items: [
      'zenkei_ato',
    ],
  },

  /** 1613_契約相違撤去線設備入力（契約電柱） */
  '1613': {
    editablePage: true,
    items: [
      'zenkei_ato',
    ],
  },

  /** 1615_契約相違撤去点設備入力（契約電柱） */
  '1615': {
    editablePage: true,
    items: [
      'zenkei_ato',
    ],
  },
};

/**
 * 竣工写真登録 テンプレート。
 * 画面ID:1061
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    /** @type import('../../../../reducks/contractDnt/operations.js').PhotoRegistlationInfo */
    const photoRegistrationInfo = this.props.photoRegistrationInfo;
    const displayItem = DISPLAY_ITEMS[photoRegistrationInfo.transitionSrcId];

    return (
      <PhotoCommon
        {...this.props}
        displayItem={displayItem}
        photoTypes={PHOTO_TYPES}
      />
    );
  }
}

Container.propTypes = {
  photoRegistrationInfo: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(Container),
);
